import React from 'react';
import img1 from '../../images/Screenshot (63).png'
import img2 from '../../images/Screenshot (92).png'
import img3 from '../../images/Screenshot (93).png'
import img4 from '../../images/Screenshot (94).png'
import img5 from '../../images/Screenshot (95).png'

const Handmedown = () => {
    return (
        <div className='md:m-10 m-4'>
            <div className='md:w-1/2 mx-auto md:my-16'>
                <h1 className='text-4xl font-bold mb-5'>Description</h1>
                <p className='text-lg'>This is a e-commerce website developed with MERN where you can buy and sell your used products from verified sellers. You can create your account as a buyer or seller. A seller can add new products or delete them if they wants. They can also advertise their unsold products which will appear in the homepage. A seller can be verified by an admin. As an admin you can delete users, check reported items. Buyers can report any items to admin and an admin can remove those reported items if needed.
                    For front-end I have used JavaScript, React JS, Firebase authentication, Tailwind and Tailwind UI for mobile and tablet responsiveness, For back-end I used Express.js, Node.js and MongoDB for crud operation. And for website hoisting I used Firebase hoisting and for image hoisting I used Image BB.</p>
                <a href="https://hand-me-down-e8b07.web.app/" target='blank'>
                    <button className='px-6 py-2 rounded-3xl mt-6 mb-10 md:mt-10 git-button'>Website</button>
                </a>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
                <img src={img1} alt="" className='rounded-xl shadow-xl' />
                <img src={img2} alt="" className='rounded-xl shadow-xl' />
                <img src={img3} alt="" className='rounded-xl shadow-xl' />
                <img src={img4} alt="" className='rounded-xl shadow-xl' />
                <img src={img5} alt="" className='rounded-xl shadow-xl' />
            </div>
        </div>
    );
};

export default Handmedown;